import { FETCH_COUNTRIES_SUCCEEDED } from './country.action';
import { pathOr } from 'ramda';

export const countryReducer = (state = [], action) => {
	switch (action.type) {
		case FETCH_COUNTRIES_SUCCEEDED: {
			return pathOr([], ['payload'], action);
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/countries/country.reducer.js